import ReactModal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';

import { closeAppointmentActionsModal } from 'store/reducers/ui';

import ActionModalContent from './ActionModalContent';
import RescheduleModalContent from './RescheduleModalContent';

export default function AppointmentActionsModal() {
  const dispatch = useDispatch();
  const { appointmentActionsModal } = useSelector((state) => state.ui);

  const closeModal = () => dispatch(closeAppointmentActionsModal());

  return (
    <ReactModal
      ariaHideApp={false}
      isOpen={appointmentActionsModal.isOpen}
      onRequestClose={closeModal}
    >
      {appointmentActionsModal.data.title === 'Reschedule' ? (
        <RescheduleModalContent
          closeModal={closeModal}
          modalData={appointmentActionsModal.data}
        />
      ) : (
        <ActionModalContent
          closeModal={closeModal}
          modalData={appointmentActionsModal.data}
        />
      )}
    </ReactModal>
  );
}
